import { SharpieImageConfig } from '../../../../common/helpers/sharpie/useSharpie';

export const imageConfig: SharpieImageConfig = {
  desktop: {
    width: 1620,
    height: 5000,
  },
  tablet: {
    width: 1620,
    height: 5000,
  },
  mobile: {
    width: 1620,
    height: 5000,
  },
};

export const contentHeroImageConfig: SharpieImageConfig = {
  desktop: {
    width: 1620,
    height: 1080,
  },
  tablet: {
    width: 1620,
    height: 1080,
  },
  mobile: {
    width: 750,
    height: 500,
  },
};

export const thumbnailImageConfig = {
  desktop: {
    width: 100,
    height: 71,
  },
  smallDesktop: {
    width: 100,
    height: 71,
  },
  tablet: {
    width: 100,
    height: 71,
  },
  mobile: {
    width: 100,
    height: 71,
  },
};
